import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const getEnvOrConfig = (key: string) => {
  return (import.meta.env[`VITE_${key}`] as string) || (import.meta.env[key] as string);
};

const firebaseConfig = {
  apiKey: getEnvOrConfig('FIREBASE_API_KEY'),
  authDomain: getEnvOrConfig('FIREBASE_AUTH_DOMAIN'),
  projectId: getEnvOrConfig('FIREBASE_PROJECT_ID'),
  storageBucket: getEnvOrConfig('FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: getEnvOrConfig('FIREBASE_MESSAGING_SENDER_ID'),
  appId: getEnvOrConfig('FIREBASE_APP_ID'),
  firestoreDatabaseId: getEnvOrConfig('FIRESTORE_DATABASE_ID') || '(default)'
};

const isDummy = (val: string | undefined) => !val || val.includes('your-') || val.includes('REPLACE_');
const hasValidConfig = !isDummy(firebaseConfig.apiKey) && !isDummy(firebaseConfig.projectId);

let app = null;
let db = null as any;
let auth = null as any;

if (hasValidConfig) {
  try {
    app = initializeApp(firebaseConfig);
    if (firebaseConfig.firestoreDatabaseId && firebaseConfig.firestoreDatabaseId !== '(default)' && firebaseConfig.firestoreDatabaseId !== 'default') {
      db = getFirestore(app, firebaseConfig.firestoreDatabaseId);
    } else {
      db = getFirestore(app);
    }
    auth = getAuth(app);
  } catch (e) {}
}

export { db, auth };



